import { useState, useEffect, useRef, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Space,

} from "antd";

const backend = process.env.REACT_APP_BACKEND;
const FinalPrompt = forwardRef((
  {
    subUnit,
  },
  promptRef,
) => {
  const navigate = useNavigate();
  
  useEffect(()=>{
  
    axios.get(`${backend}/contents/content_sentence/ai/gpt/final_prompt/${subUnit.value}`)
    .then(res=>{
      promptRef.current.setFieldValue("prompt_text",res.data.data[0]?.prompt_text)
    })
    .catch(err=>{
      console.log(err);
      if(err.response && err.response.status===401) {
        navigate("/auth")
      }
    })
  },[])

  return (
    <Form
    ref={promptRef}
    >
      <Space direction="vertical" style={{width:"100%"}}>
        <Form.Item name="prompt_text">
          <Input.TextArea
            autoSize
          />
        </Form.Item>
      </Space>
    </Form>
  )
});
export default FinalPrompt;